import script from "./SearchBenefits.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBenefits.vue?vue&type=script&setup=true&lang=js"

import "./SearchBenefits.vue?vue&type=style&index=0&id=3c8b1ada&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c8b1ada"]])

export default __exports__